import { AxiosError } from 'axios'
import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import { LoadingState, ValidationError } from '../../../types/commonTypes'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import { RootState } from '../../../stateStore'
import {
  AssetTransactionListProps,
  AssetTransactionListSliceState,
  GetAssetTransactionList,
  AssetTransactionalListResponse,
} from '../../../types/Assets/AssetTransactionalList/AssetTransactionalListTypes'
import assetTransactionalListApi from '../../../middleware/api/Assets/AssetTransationalList/assetTransationalListApi'

const getAssetTransactionList = createAsyncThunk(
  'assetManagement/assetTransactionalList',
  async (props: AssetTransactionListProps, thunkApi) => {
    try {
      return await assetTransactionalListApi.getAssetTransactionList(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const curMonthVal = 'Current Month'
const status = ''
const assetTypeVal = ''
const productTypeVal = ''
const searchByEmpVal = false
export const initialAssetTransactionListState: AssetTransactionListSliceState =
  {
    assetTransactionakDetails: [],
    getAssetTransactionList: {} as GetAssetTransactionList,
    isLoading: ApiLoadingState.idle,
    listSize: 0,

    selectedMonthValue: curMonthVal,
    assetTypeValue: assetTypeVal,
    ProductTypeFilterValue: productTypeVal,
    statusValue: status,
    fromDateValue: '',
    toDateValue: '',
    searchInputFieldValue: '',
    searchByEmployeeNameValue: searchByEmpVal,
  }

const assetTransactionListSlice = createSlice({
  name: 'assetTransactionList',
  initialState: initialAssetTransactionListState,
  reducers: {
    setCurrentMonthValue: (state, action) => {
      state.selectedMonthValue = action.payload
    },
    clearSelectedMonth: (state) => {
      state.selectedMonthValue = ''
    },
    setStatusFilterValue: (state, action) => {
      state.statusValue = action.payload
    },
    clearStatusFilterValue: (state) => {
      state.statusValue = ''
    },
    setAssetTypeFilter: (state, action) => {
      state.assetTypeValue = action.payload
    },
    clearAssetType: (state) => {
      state.assetTypeValue = ''
    },
    setProductTypeFilterValue: (state, action) => {
      state.ProductTypeFilterValue = action.payload
    },
    cleartProductTypeFilterValue: (state) => {
      state.ProductTypeFilterValue = ''
    },
    setFromDateVal: (state, action) => {
      state.fromDateValue = action.payload
    },
    setToDateVal: (state, action) => {
      state.toDateValue = action.payload
    },
    setSearchInputVal: (state, action) => {
      state.searchInputFieldValue = action.payload
    },
    clearSetSearchInputVal: (state, action) => {
      state.searchInputFieldValue = action.payload
    },
    setSearchByEmployeeVal: (state, action) => {
      state.searchByEmployeeNameValue = action.payload
    },
    clearSearchByEmployeeVal: (state, action) => {
      state.searchByEmployeeNameValue = action.payload
    },
    clearAssetTransactionListType: (state, action) => {
      state.assetTransactionakDetails = action.payload
    },
  },

  extraReducers: (builder) => {
    builder
      .addMatcher(isAnyOf(getAssetTransactionList.pending), (state) => {
        state.isLoading = ApiLoadingState.loading
      })
      .addMatcher(
        isAnyOf(getAssetTransactionList.fulfilled),
        (state, action) => {
          state.isLoading = ApiLoadingState.succeeded
          state.assetTransactionakDetails = action.payload.list
          state.listSize = action.payload.size
        },
      )
  },
})

const assetTransactionListThunk = {
  getAssetTransactionList,
}

const isLoading = (state: RootState): LoadingState => {
  return state.assetTransactionList.isLoading
}
const assetTransactionList = (
  state: RootState,
): AssetTransactionalListResponse[] =>
  state.assetTransactionList.assetTransactionakDetails

const listSize = (state: RootState): number =>
  state.assetTransactionList.listSize

const getSelectedMonthValue = (state: RootState): string =>
  state.assetTransactionList.selectedMonthValue

const getSelectedAssetStatusFilterValue = (state: RootState): string =>
  state.assetTransactionList.statusValue

const getSelectedAssetTypeFilterValue = (state: RootState): string =>
  state.assetTransactionList.assetTypeValue

const getSelectedProductTypeFilterValue = (state: RootState): string =>
  state.assetTransactionList.ProductTypeFilterValue

const getFromDateValue = (state: RootState): string | Date =>
  state.assetTransactionList.fromDateValue

const getToDateValue = (state: RootState): string | Date =>
  state.assetTransactionList.toDateValue

const getSearchInputFieldValue = (state: RootState): string =>
  state.assetTransactionList.searchInputFieldValue

const getSearchByEmpNameVal = (state: RootState): boolean =>
  state.assetTransactionList.searchByEmployeeNameValue
export const assetTransactionListSelectors = {
  isLoading,
  assetTransactionList,
  listSize,

  getSelectedMonthValue,
  getSelectedAssetStatusFilterValue,
  getSelectedAssetTypeFilterValue,
  getSelectedProductTypeFilterValue,
  getFromDateValue,
  getToDateValue,
  getSearchInputFieldValue,
  getSearchByEmpNameVal,
}

export const assetTransactionListService = {
  ...assetTransactionListThunk,
  actions: assetTransactionListSlice.actions,
  selectors: assetTransactionListSelectors,
}

export default assetTransactionListSlice.reducer
